function Error() {
  return (
    <div className='mx-auto p-8'>
      <h1 className='text-center'>404 Error</h1>
      <h2 className='text-center'>This page could not be found</h2>
      <img
        src='https://banner2.cleanpng.com/20180701/kbc/kisspng-http-404-error-message-information-not-found-5b38efc8711914.6829505415304580564633.jpg'
        alt='404 page '
      />
    </div>
  )
}

export default Error
